<template>
    <!-- 融资发布&信用公示 -->
    <div class="PlatformTarget">
        <div class="box">
            <div class="imgTitle">
                <img src="../../assets/img/new/目标.png" alt="图片加载失败">
                <span style="color: aliceblue;">场景金融</span>
            </div>

            <!-- <div class="underline">
                <div></div>
            </div> -->
            <div class="container">
                <!-- 供应链场景服务系统 -->
                <div class="boxs">
                    <div class="contentAndImg">
                        <div class="showImg">
                            <img src="../../assets/img/new/供应链场景服务系统.png" class="centered-img" />
                        </div>
                        <div class="showContent">
                            <div class="targetTitle">供应链场景服务系统</div>
                            <div class="contentBG1">
                                <div style="margin-left: 10px;margin-right: 10px;margin-top: 10px; margin-bottom: 10px;">
                                    <div class="contentStyle">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于本区域内大型、中型、工业规模以上企业、农业龙头企业以及产业集群、大型商圈供应链条场景数据，
                                        搭建供应链金融服务系统，以此，目标精准的为处于链条上的区域内中小微企业提供融资服务。
                                    </div>
                                </div>

                                <div class="littleItem1" @click="showPopupLittleItem1"> FIRST </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="boxs">
                    <div class="contentAndImg">
                        <div class="showImg">
                            <img src="../../assets/img/new/政务数字场景金融服务系统.png" class="centered-img" />
                        </div>
                        <div class="showContent">
                            <div class="targetTitle">政务数字场景金融服务系统</div>
                            <div class="contentBG2">
                                <div style="margin-left: 10px;margin-right: 10px;margin-top: 10px; margin-bottom: 10px;">
                                    <div class="contentStyle">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于政府采购、政策扶持、财政补贴等政务数字，打造政务场景数字金融服务系统，为政策受益企业提供叠加金融服务。
                                    </div>
                                </div>

                                <div class="littleItem2" @click="showPopupLittleItem2"> SECOND </div>

                            </div>
                        </div>

                    </div>
                </div>

                <div class="boxs">
                    <div class="contentAndImg">
                        <div class="showImg">
                            <img src="../../assets/img/new/科创金融服务系统.png" class="centered-img" />
                        </div>
                        <div class="showContent">
                            <div class="targetTitle">科创金融服务系统</div>
                            <div class="contentBG3">
                                <div style="margin-left: 10px;margin-right: 10px;margin-top: 10px; margin-bottom: 10px;">
                                    <div class="contentStyle">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;平台建立区域科创企业信用数据库，通过完善每一个科创企业的信用画像，为科创企业量身定制融资模式。
                                    </div>
                                </div>

                                <div class="littleItem3" @click="showPopupLittleItem3"> THIRD </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <el-dialog  custom-class="custom-dialog" v-if="popupVisibleLittleItem1" title="供应链场景服务系统案例" :visible.sync="popupVisibleLittleItem1"
                width="60%">
                <!-- <span>这是弹窗的内容。</span> -->
                <!-- <span style="text-align: center; font-weight: 700; font-size: 2px;">区域宏观运行指标概览</span> -->
                <el-image style="width: 99%; height: 50%" :src="url01" :preview-src-list="srcList">
                </el-image>
                <!-- <div style="width:20px; float: none;"></div> -->
                <!-- <span>区域市场主体概览</span> -->
                <el-image style="width: 99%; height: 50%" :src="url02" :preview-src-list="srcList">
                </el-image>
            </el-dialog>

            <el-dialog v-if="popupVisibleLittleItem2" title="政务数字场景金融服务系统" :visible.sync="popupVisibleLittleItem2"
                width="80%">
                <!-- <span>这是弹窗的内容。</span> -->
                <div class="littleItem2Continer">
                    <!-- 左侧图片 -->
                    <img class="dialogImg" src="../../assets/img/new/政务数字场景金融服务系统dialog.jpg" />
                    <div class="rightContenAndUnderLine">

                        <!-- 右侧文字描述 -->
                        <div class="dialogContent">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;政务大数据取之于民，用之于民，结合企业固定资产登记、水电气、税务等政务大数据以及互联网三方数据,
                            构建“1+N”的多维数据资源,利用人工智能和大数据技术为客户精准画像,
                            全面分析客户的还款能力、还款意愿和风险系数,系统自动评级,为客户提供信用贷款产品,依托政务场景创造出数字化金融新模式。
                        </div>
                    </div>
                </div>
            </el-dialog>

            <el-dialog v-if="popupVisibleLittleItem3" title="科创金融服务系统" :visible.sync="popupVisibleLittleItem3" width="60%">
                <!-- <span>这是弹窗的内容</span> -->
                <el-image style="width: 99%; height: 50%" :src="url03">

                </el-image>
            </el-dialog>


        </div>
    </div>
</template>

<script>
import screen01 from '../../assets/img/区域宏观运行指标概览.jpg';
import screen02 from '../../assets/img/区域市场主体概览.jpg';
import KeChuangDialog from '../../assets/img/new/科创金融服务系统dialog.png'
//导入css样式表
import '../../assets/css/PlatformTarget.css'
export default {
    name: "PlatformTarget",
    data() {
        return {
            // 弹出框
            popupVisibleLittleItem1: false,
            popupVisibleLittleItem2: false,
            popupVisibleLittleItem3: false,
            // 弹出图片
            url01: screen01,
            url02: screen02,
            url03: KeChuangDialog,
            srcList: [
                screen01,
                screen02
            ],
        }
    },
    mounted() {


    },
    computed: {

    },
    methods: {
        showPopupLittleItem1() {
            this.popupVisibleLittleItem1 = true;
        },
        showPopupLittleItem2() {
            this.popupVisibleLittleItem2 = true;
        },
        showPopupLittleItem3() {
            console.log(111)
            this.popupVisibleLittleItem3 = true;
        },
    },

}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Department_Industry_Finance/PlatformTarget.vue